import COLORS from 'pared/constants/colors'
import { ILossPreventionConfigType } from 'pared/pages/CorporateLossPrevention/hooks/useLossPreventionConfig'

export const mwbConfig: ILossPreventionConfigType = {
  kpiSettings: [
    { category: 'basic', key: 'compsTotalAmount', title: 'Total Discounts' },
    {
      category: 'basic',
      key: 'compsTotalCount',
      title: 'Total Discount Counts',
    },
    { category: 'custom', type: 'Deletes', title: 'Deletes', key: 'amount' },
    {
      category: 'custom',
      type: 'Voids',
      title: 'Voids',
      key: 'amount',
    },
    {
      category: 'custom',
      type: 'Overrings',
      title: 'Overrings',
      key: 'amount',
    },
    {
      category: 'custom',
      type: 'Refunds',
      title: 'Refunds',
      key: 'amount',
    },
  ],

  discountTable: {
    isVisible: true,
    shouldColorOnPercent: true,
    discountColumns: [
      {
        key: 'Coupons',
        title: 'Coupons',
      },
      {
        key: 'Employee Meal',
        title: 'Employee Meal .75%',
      },
      {
        key: 'Promo Meal',
        title: 'Promo Meal .5%',
      },
      {
        key: 'Police Discount',
        title: 'Police Discount',
      },
      {
        key: 'Trainer Promo',
        title: 'Trainer Promo .5%',
      },
      {
        key: 'Mobile Courtesy Meal',
        title: 'Mobile Courtesy Meal',
      },
    ],
    getColorFromValue: (type: string, value: number) => {
      switch (type) {
        case 'Promo Meal':
        case 'Trainer Promo': {
          if (value >= 0.005) return COLORS.PomodoroTransparent
          break
        }

        case 'Employee Meal':
          if (value >= 0.0075) return COLORS.PomodoroTransparent
          break
      }

      return 'transparent'
    },
  },

  discountTrendChart: {
    isVisible: true,
    yLeftAxisLabel: '$ Discount',
    yLeftAxisValueType: 'percent',
    yLeftAxisKpiDefs: [],
    includeBreakdown: true,
  },

  cashControlTable: {
    isVisible: true,
    getColorFromValue: (type: string, value: number) => {
      switch (type) {
        case 'Overrings': {
          if (value >= 0.35) return COLORS.PomodoroTransparent
          break
        }

        case 'Refunds': {
          if (value >= 0.08) return COLORS.PomodoroTransparent
          break
        }

        case 'cashovershort': {
          if (Math.abs(value) >= 0.1) return COLORS.PomodoroTransparent
          break
        }
      }

      return 'transparent'
    },
    cashControlColumns: [
      {
        key: 'Deletes',
        title: 'Deletes',
        width: '150px',
        children: [
          {
            key: 'Deletes.count',
            title: '#',
            valueType: 'count',
          },
          {
            key: 'Deletes.amount',
            title: '$',
            valueType: 'price',
          },
        ],
      },
      {
        key: 'Voids',
        title: 'Voids',
        width: '150px',
        children: [
          {
            key: 'Voids.count',
            title: '#',
            valueType: 'count',
          },
          {
            key: 'Voids.amount',
            title: '$',
            valueType: 'price',
          },
        ],
      },
      {
        key: 'Overrings',
        title: 'Overrings .35%',
        width: '150px',
        children: [
          {
            key: 'Overrings.count',
            title: '#',
            valueType: 'count',
          },
          {
            key: 'Overrings.amount',
            title: '$',
            valueType: 'price',
          },
          {
            key: 'Overrings.checkPercent',
            title: '%',
            valueType: 'percent',
          },
        ],
      },
      {
        key: 'Refunds',
        title: 'Refunds .08%',
        width: '150px',
        children: [
          {
            key: 'Refunds.count',
            title: '#',
            valueType: 'count',
          },
          {
            key: 'Refunds.amount',
            title: '$',
            valueType: 'price',
          },
          {
            key: 'Refunds.checkPercent',
            title: '%',
            valueType: 'percent',
          },
        ],
      },
      {
        key: 'Cash Over/Short',
        title: 'Cash Over/Short +/- 0.1%',
        width: '150px',
        children: [
          {
            key: 'cashOverOrShort.amount',
            title: '$',
            valueType: 'price',
          },
          {
            key: 'cashOverOrShort.checkPercent',
            title: '%',
            valueType: 'percent',
          },
        ],
      },
    ],
  },

  cashControlTrendChart: {
    isVisible: true,
    yLeftAxisLabel: '% of Sales',
    yLeftAxisValueType: 'percent',
    yLeftAxisKpiDefs: [
      {
        key: 'Deletes',
        name: 'Deletes %',
        kpiKey: 'percentOfSales',
        valueType: 'percent',
        color: COLORS.Plum,
        hidden: false,
      },
      {
        key: 'Voids',
        name: 'Voids %',
        kpiKey: 'percentOfSales',
        valueType: 'percent',
        color: COLORS.Pomodoro,
        hidden: false,
      },
      {
        key: 'Overrings',
        name: 'Overrings %',
        kpiKey: 'percentOfSales',
        valueType: 'percent',
        color: COLORS.DarkOrchid,
        hidden: false,
      },
      {
        key: 'Refunds',
        name: 'Refund %',
        kpiKey: 'percentOfSales',
        valueType: 'percent',
        color: COLORS.Mango,
        hidden: false,
      },
    ],
  },
}
